<template>
  <div class="login-form">
    <div class="input-form">
      <p class="register-successful-title">Thanks for creating your account!</p>
      <p class="register-successful-title">We just need you to email <u>customersuccess@cortextech.io</u>, to tell us you’ve created an account. We’ll then set up the rest of your account for the next time you log in.</p>
      
      <button class="form-button" @click.prevent="sendEmail">Email us</button>
    </div>
  </div>
</template>


<script>

export default {
  methods: {
    sendEmail() {
      location.href='mailto:customersuccess@cortextech.io';
    }
  }
}
</script>

<style>
.register-successful-title {
  text-align: left;
}
</style>